<template>
  <div class="phonePage01" :style="bg">
    <div class="pt_logo">
      <img src="@/assets/images/logo02.png" alt="" />
    </div>
    <div class="pm_area">
      <div class="pm_title">京诚所致 哲安天下</div>
      <!-- <div class="pm_label">JINGCHENGSUOZHI ZHEANTIANXIA</div> -->
    </div>
    <div class="pb_area">
      <div class="icon_mouse" style="width: 1.4rem;height: 2.1rem;"></div>
      <div class="pb_text">鼠标下滑探索</div>
    </div>

    <!-- <img v-if="!vedioCanPlay" class="login-background" :src="$tools.localStorageFn.get('PAGE_DATE').banner" />
    <div class="videoContainer" v-else>
      <video id="video" ref="video" class="fillWidth" playsinline="" autoplay="" muted="" loop="" v-on:canplay="canplay">
        <source :src="$tools.localStorageFn.get('PAGE_DATE').banner_video" type="video/mp4" />
      </video>
    </div> -->

    <floatService></floatService>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bg: {
        background: "url(" + this.$tools.localStorageFn.get("PAGE_DATE").banner +
          ") no-repeat center center"
      },
      vedioCanPlay: false,
    };
  },
  created() {
    // if (this.isWeiXin()) {
    //   this.vedioCanPlay = false;
    // } else {
    //   this.vedioCanPlay = true;
    // }
  },
  mounted() {
  },
  methods: {
    //视屏播放失败展示背景图片
    // canplay() {
    //   this.vedioCanPlay = true;
    // },

    // isWeiXin() {
    //   var ua = window.navigator.userAgent.toLowerCase();
    //   if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
  },
};
</script>


<style lang="scss" scoped>
.phonePage01 {
  height: 100%;
  width: 100%;
  // background: url(~@/assets/images/phoneBg01.png) no-repeat center center;
  background-size: cover !important;
  position: relative;

  .login-background {
    width: 100%;
    height: 100%;
    display: block;
    position: fixed;
    top: 0;
    height: 100%;
    left: 0;
    z-index: -99;
  }

  .videoContainer {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -100;

    .fullscreenVideo {
      height: 100%;
      width: 100%;
    }

    video {
      height: 100%;
      object-fit: fill;
    }
  }

  .videoContainer:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    z-index: -1;
    top: 0;
    left: 0;
    background: rgba(25, 29, 34, 0.65);
  }

  .pt_logo {
    position: absolute;
    top: 2.1rem;
    left: 2.5rem;
    width: 11.1rem;
    height: 2.5rem;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .pm_area {
    position: relative;
    top: 46.36%;
    text-align: center;

    .pm_title {
      font-size: 3.0rem;
      font-family: JingZhe_XiaoWei;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 1.7rem;
    }

    .pm_label {
      font-size: 1.3rem;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      color: #ffffff;
      letter-spacing: 0.2rem;
      word-spacing: 1.0rem;
    }
  }

  .pb_area {
    width: 100%;
    position: absolute;
    bottom: 12.26%;
    text-align: center;

    .icon_mouse {
      margin: 0 auto;
      width: 1.4rem;
      height: 2.1rem;
      background: url(~@/assets/images/icon_mouse.png) no-repeat center center;
      background-size: 100% 100%;
      margin-bottom: 1.1rem;
    }

    .pb_text {
      font-size: 1.1rem;
      font-family: SimHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 1.3rem;
      position: static;
    }
  }
}

.active {
  .phonePage01 {
    .pm_title {
      animation: focus-in-contract 2s ease 0s 1 normal none;
    }

    .pm_label {
      animation: focus-in-contract 2s ease 0s 1 normal none;
    }
  }
}
</style>